import { render, staticRenderFns } from "./SubscriptionServiceBreakdown.vue?vue&type=template&id=026049de&scoped=true"
import script from "./SubscriptionServiceBreakdown.vue?vue&type=script&lang=js"
export * from "./SubscriptionServiceBreakdown.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionServiceBreakdown.vue?vue&type=style&index=0&id=026049de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026049de",
  null
  
)

export default component.exports